import {useMutation} from "@apollo/client";
import {useState} from "react";
import {FiTrash} from "react-icons/fi";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ButtonAction} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {GQL_CHECKS_QUERY2} from "@/lib/queries/checks.ts";
import {GQL_UNLINK_SERVICE_FROM_MAINTENANCE_SCHEDULE} from "@/lib/queries/maintenance.ts";
import {Service} from "@/lib/types/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

interface UnlinkCheckButtonProps {
  scheduleId: number;
  check: Pick<Service, "id" | "name">;
}

export const UnlinkCheckButton = ({scheduleId, check}: UnlinkCheckButtonProps) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [unlinkService, {loading}] = useMutation<GraphQLResponse<null>>(GQL_UNLINK_SERVICE_FROM_MAINTENANCE_SCHEDULE, {
    refetchQueries: [GQL_CHECKS_QUERY2],
  });

  const handleConfirmUnlink = async () => {
    const response = await unlinkService({
      variables: {
        scheduleId,
        serviceId: check.id,
      },
    });

    if (response?.data?.response?.status === ResponseStatus.SUCCESS) {
      setShowConfirmation(false);
    }
  };

  return (
    <>
      <ButtonAction onClick={() => setShowConfirmation(true)} tooltip="Remove from schedule">
        <Icon icon={FiTrash} />
      </ButtonAction>
      <DeleteActionDialog
        show={showConfirmation}
        title="Remove Check from Schedule"
        loading={loading}
        onCancel={() => setShowConfirmation(false)}
        onConfirm={handleConfirmUnlink}
      >
        Are you sure you want to remove <span className={"pulseTextBodyBold"}>{check.name}</span> from this maintenance
        schedule?
      </DeleteActionDialog>
    </>
  );
};
